export default __webpack_public_path__ + "static/media/Logo-embrapi-1.7ee9d228.png";